import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

import useMediaQuery from '@material-ui/core/useMediaQuery';

import getSystemTheme from '../api/helpers/getSystemTheme';

const useOsPrefersDark = () => {
  const osPrefersDark = useMediaQuery('(prefers-color-scheme: dark)');
  const [isOsDark, setIsOsDark] = useState(osPrefersDark);
  const [platform, setPlatform] = useState('web');

  const config = useSelector(state => state.config);

  useEffect(
    () => {
      if (config) {
        setPlatform(config.platform);
      }
    },
    [config],
  );

  useEffect(
    () => {
      if (platform === 'app') {
        getSystemTheme().then(systemTheme => {
          setIsOsDark(systemTheme === 'dark');
        });
      } else {
        setIsOsDark(osPrefersDark);
      }
    },
    [osPrefersDark, platform],
  );

  return isOsDark;
};

export default useOsPrefersDark;
